var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconComponent,_vm._b({tag:"component",staticClass:"inline-block fill-current",class:[_vm.iconSize, _vm.custom],attrs:{"role":"img"}},'component',_vm.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }